import { GlobalsService } from "src/app/api/globals.service";
import { Component, Input, OnInit } from "@angular/core";
import { ActividadesService } from "src/app/services/actividades.service";
import { AuthService } from "src/app/services/auth.service";
import { ComponentDataService } from "src/app/services/component-data.service";
import { CursosService } from "src/app/services/cursos.service";
import {
  AlertController,
  InfiniteScrollCustomEvent,
  ModalController,
} from "@ionic/angular";
import * as internal from "stream";
import * as jQuery from "jquery";
import { Observable } from "rxjs";
import { FormControl } from "@angular/forms";
import { debounceTime } from "rxjs/operators";
import { SeleccionarFechaEntregaComponent } from "./seleccionar-fecha-entrega/seleccionar-fecha-entrega.component";
import { environment } from "src/environments/environment";
import { Location } from "@angular/common";
import { Router } from "@angular/router";
import { statusCurse } from "src/app/Enum/statusCurse.enum";
import { ToastService } from "src/app/services/toast.service";

@Component({
  selector: "app-crear-actividad-actividades",
  templateUrl: "./crear-actividad-actividades.component.html",
  styleUrls: ["./crear-actividad-actividades.component.scss"],
})
export class CrearActividadActividadesComponent implements OnInit {
  @Input() public curso: any;
  @Input() public opcion: any;
  @Input() public ACTIVIDADES_CONFIG: any = [];
  @Input() public ACTIVIDAD_CURSO_CONFIG: any = [];
  @Input() public DATA_CURSO: any = [];
  i: number = 0;
  ID: number;
  AUTH_KEY: string;
  ACTIVIDADES: any = [];
  //ACTIVIDADES_CONFIG:any = [];
  ACTIVIDAD_CURSO: any = [];
  // ACTIVIDAD_CURSO_CONFIG:any = [];
  LIBROS_USERS: any = [];
  CURSOS_USERS: any = [];
  CONTINUE: number;
  TIND_Active = -1;
  Load: boolean;
  idSearch: number;
  isSearch: boolean;
  searchTipo: number;
  componente: number;
  dataOpcion: number;
  actividadActual: any;
  imgUrl = "";
  statusCurse = statusCurse;
  page = 1;
  totalpages = 0;
  usersList: any = [];
  actividadSelected: any;
  isMobile = false;

  public searchControlUsers: FormControl;
  dataLoaded = false;
  constructor(
    private authService: AuthService,
    public actividadesService: ActividadesService,
    private cursosService: CursosService,
    public alertController: AlertController,
    private modalCtrl: ModalController,
    private _location: Location,
    public router: Router,
    public toastService: ToastService,
    public dataService: ComponentDataService,
    public globalsService: GlobalsService
  ) {
    this.isMobile = this.globalsService.isMobile;
    this.Load = false;
    this.searchControlUsers = new FormControl();
    this.imgUrl = environment.host + "/uploads/assets/imagenes/productos/";
    this.dataOpcion = 1;
    this.dataService.itemSelectedMenu.subscribe((data) => {
      this.dataOpcion = data;
      if (data == 1) {
        this.resetDataLoad();
      }
    });
  }

  ngOnInit() {
    this.authService.userData$.subscribe((res: any) => {
      let auth_key = "";
      let rsponse: any = res;
      if (rsponse.auth_key != undefined) {
        auth_key = rsponse.auth_key;
        this.ID = rsponse.id;
        this.AUTH_KEY = auth_key;
        this.getActividades();
      }

      this.idSearch = 0;
      this.isSearch = false;
      this.searchTipo = 0;
      this.searchControlUsers.valueChanges
        .pipe(debounceTime(700))
        .subscribe((searchText) => {
          this.usersList = [];
          this.page = 1;
          this.setFilteredItems(searchText);
        });
    });
  }

  resetDataLoad() {
    this.dataLoaded = false;
    this.ACTIVIDAD_CURSO = [];
    this.ACTIVIDADES = [];
    this.getActividades();
  }

  getActividades() {
    this.ACTIVIDAD_CURSO = [];
    this.actividadesService
      .getAllActividadesCursos(this.AUTH_KEY, this.curso.id)
      .subscribe((response) => {
        if (response !== undefined) this.ACTIVIDADES = response;
        this.CONTINUE = 0;
        this.Load = true;
        this.imgUrl = environment.host + "/uploads/assets/imagenes/productos/";

        if (this.ACTIVIDADES) {
          this.ACTIVIDADES.forEach((element, i) => {
            let ids: any = [];
            let id_libro_nodata = element.data.id;
            if (element.actividades.data != undefined) {
              element.actividades.activities.forEach((element, i) => {
                ids.push({
                  id_actividad: element[0].data.id_actividad,
                  id_tipo: element[0].data.id_tipo,
                });
              });
              let disponible = 1;
              let t_individual = 0;
              let t_individualArray = [];
              let calificable = 1;
              let o_aleatorio = 1;
              let id_libro = element.data.id;
              let tipo = 1;

              // if(!this.findValueInArrayOb(element.data.id,element)){
              // alert(element.data.id);
              // }
              let filtered;
              filtered = this.arrayExistIndex(
                id_libro,
                this.ACTIVIDADES_CONFIG
              );
              // if(filtered){
              //   console.log("FILTER Exist: "+id_libro);
              // }else{
              //   console.log("FILTER No exist: "+id_libro);
              // }
              if (!filtered)
                this.ACTIVIDADES_CONFIG.push({
                  actividades: ids,
                  //"id_tipo":element.actividades.activities[0][0].data.id_tipo,
                  disponible: disponible,
                  t_individual: t_individual,
                  t_individualArray: t_individualArray,
                  calificable: calificable,
                  o_aleatorio: o_aleatorio,
                  id_libro: id_libro,
                  tipo: tipo,
                });
            } else {
              let filtered;
              filtered = this.arrayExistIndex(
                id_libro_nodata,
                this.ACTIVIDADES_CONFIG
              );
              if (!filtered)
                this.ACTIVIDADES_CONFIG.push({
                  id_libro: id_libro_nodata,
                  tipo: 0,
                });
            }
            this.CONTINUE = this.ACTIVIDADES.length;
          });
        }

        // getActividadCurso
        this.cursosService
          .getActividadCurso(this.ID, this.curso.id, this.AUTH_KEY, "1")
          .subscribe((res: any) => {
            this.dataLoaded = true;
            //mapea los que son actividades del curso y las que son de los libos
            res.map((element) => {
              element.data.map((element2) => {
                if (element2.id_libro == null) {
                  this.ACTIVIDAD_CURSO.push(element);
                } else {
                  this.ACTIVIDADES.forEach((element3) => {
                    if (element3.data.id == element2.id_libro) {
                      element3.actividades.push(element);
                    }
                  });
                }
              });
            });
            if (!res.error) {
              // this.ACTIVIDAD_CURSO = res;
              if (this.ACTIVIDAD_CURSO) {
                let ids_c: any = {};
                this.ACTIVIDAD_CURSO.forEach((element) => {
                  ids_c = {};
                  if (element.size > 0) {
                    element.activities.forEach((element2) => {
                      if (element2) {
                        ids_c = {
                          id_actividad: element2.data.id_actividad,
                          id_tipo: element2.data.id,
                        };
                      }
                    });
                  }
                  let id_curso = element.data[0].id;
                  let filtered;
                  filtered = this.arrayExistIndexCurso(
                    id_curso,
                    this.ACTIVIDAD_CURSO_CONFIG
                  );
                  // if(filtered){
                  //   console.log("FILTER Exist: "+id_curso);
                  // }else{
                  //   console.log("FILTER No exist: "+id_curso+"rr");
                  // }
                  if (!filtered) {
                    this.ACTIVIDAD_CURSO_CONFIG.push({
                      id: element.data[0].id,
                      actividades: ids_c,
                      disponible: 1,
                      t_individual: 0,
                      t_individualArray: [],
                      calificable: 1,
                      o_aleatorio: 1,
                      id_curso: element.id_curso,
                      tipo: 2,
                    });
                  }
                });
              }
            }
          });
      });
  }
  arrayExistIndex(valor, array) {
    let filtered = false;
    array.forEach((element, i, array) => {
      // console.log('FILTER: ',element.id_libro);
      // console.log('FILTER valor: ',valor);
      if (element.id_libro == valor) {
        filtered = true;
      }
      if (i == array.length - 1) {
      }
    });
    return filtered;
  }
  arrayExistIndexCurso(valor, array) {
    let filtered = false;
    array.forEach((element, i, array) => {
      // console.log('FILTER: ',element.id_libro);
      // console.log('FILTER valor: ',valor);
      if (element.id == valor) {
        filtered = true;
      }
      if (i == array.length - 1) {
      }
    });
    return filtered;
  }

  getConfActividad(id_libro) {
    let id_act = 0;
    this.ACTIVIDADES_CONFIG.forEach((element) => {
      if (element.id_libro == id_libro) {
        id_act = element.disponible;
      }
    });
    return id_act;
  }
  getConfActividadCurso(id) {
    let id_act = 0;
    this.ACTIVIDAD_CURSO_CONFIG.forEach((element) => {
      if (element.id == id) {
        id_act = element.disponible;
      }
    });
    return id_act;
  }
  getConfCalificable(id_libro) {
    let id_cal = 0;
    this.ACTIVIDADES_CONFIG.forEach((element) => {
      if (element.id_libro == id_libro) {
        id_cal = element.calificable;
      }
    });
    return id_cal;
  }

  getConfCalificableCurso(id) {
    let id_cal = 0;
    this.ACTIVIDAD_CURSO_CONFIG.forEach((element) => {
      if (element.id == id) {
        id_cal = element.calificable;
      }
    });
    return id_cal;
  }
  getConfOAleatorio(id_libro) {
    let id_oal = 0;
    this.ACTIVIDADES_CONFIG.forEach((element) => {
      if (element.id_libro == id_libro) {
        id_oal = element.o_aleatorio;
      }
    });
    //
    return id_oal;
  }
  getConfOCursoAleatorio(id) {
    let id_oal = 0;
    this.ACTIVIDAD_CURSO_CONFIG.forEach((element) => {
      if (element.id == id) {
        id_oal = element.o_aleatorio;
      }
    });
    return id_oal;
  }

  actividadDisponible(event) {
    //return;
    let estado = 0;
    this.ACTIVIDADES_CONFIG.forEach((element) => {
      if (element.id_libro == event.target.dataset.id_libro) {
        estado = element.disponible = parseInt(event.detail.value);
      }
    });
  }

  actividadCursoDisponible(event, id) {
    console.log(
      "🚀 ~ CrearActividadActividadesComponent ~ actividadCursoDisponible ~ id:",
      id,
      this.curso.id
    );
    let estado = 0;
    this.ACTIVIDAD_CURSO_CONFIG.forEach((element) => {
      if (element.id == event.target.dataset.curso) {
        estado = element.disponible = parseInt(event.detail.value);
      }
    });

    this.actividadesService
      .setActividadDisponible(this.ID, this.AUTH_KEY, id, this.curso.id)
      .subscribe((data) => {
        this.toastService.presentToast(
          "La actividad se actualizo correctamente"
        );
        this.getActividades();
      });
  }

  actividadCalificable(event) {
    let estado = 0;
    this.ACTIVIDADES_CONFIG.forEach((element) => {
      if (element.id_libro == event.target.dataset.id_libro) {
        estado = element.calificable = parseInt(event.detail.value);
      }
    });
  }
  actividadCursoCalificable(id) {
    this.actividadesService
      .actividadCursoCalificable(this.ID, this.AUTH_KEY, id, this.curso.id)
      .subscribe((data) => {
        if (data.validate) {
          this.toastService.presentToast(
            "La actividad se actualizo correctamente"
          );
          this.getActividades();
        } else {
          this.toastService.presentToast(
            "¡Ocurrió un error, inténtelo más tarde!"
          );
        }
      });
  }
  actividadOAleatorio(event) {
    let estado = 0;
    this.ACTIVIDADES_CONFIG.forEach((element) => {
      if (element.id_libro == event.target.dataset.id_libro) {
        estado = element.o_aleatorio = parseInt(event.detail.value);
      }
    });
  }
  actividadOCursoAleatorio(event) {
    let estado = 0;
    this.ACTIVIDAD_CURSO_CONFIG.forEach((element) => {
      if (element.id == event.target.dataset.curso) {
        estado = element.o_aleatorio = parseInt(event.detail.value);
      }
    });
  }

  actividadDisponibleEstado(id_lib) {
    //ACTIVIDADES_CONFIG[i].disponible
    let estado = 0;
    this.ACTIVIDADES_CONFIG.forEach((element) => {
      if (element.id_libro === id_lib) {
        estado = parseInt(element.disponible);
      }
    });
    return estado;
  }

  //C R U D

  createActivities() {
    this.dataOpcion = 2;
    this.componente = 1;
  }

  viewActivities(actividad: any) {
    console.log("Ver actividad ..");
    this.dataOpcion = 3;
    this.componente = 2;
    this.actividadActual = actividad;
  }
  updateActivities(actividad: any) {
    console.log("Modificar actividad ..", actividad);
    this.dataOpcion = 3;
    this.componente = 3;
    this.actividadActual = actividad;
  }

  deleteActivities(item) {
    this.presentAlertConfirmAct(item);
  }

  deleteBook(item) {
    this.presentAlertConfirm(item);
  }

  cancelarActividad() {
    this.dataOpcion = 1;
  }

  async presentAlertConfirm(event) {
    const alert = await this.alertController.create({
      cssClass: "rm-book-alert",
      header: "¿Desa eliminar este libro?",
      message: "",
      buttons: [
        {
          text: "Cancelar",
          role: "cancel",
          cssClass: "secondary",
          handler: (blah) => {},
        },
        {
          text: "Continuar",
          handler: () => {
            let id_libro = event.data.id;
            this.cursosService
              .rmCursoLibro(this.ID, this.curso.id, id_libro, this.AUTH_KEY)
              .subscribe((res: any) => {
                if (!res.error) {
                  this.toastService.presentToast(
                    "El libro se eliminó correctamente"
                  );
                  this.resetDataLoad();
                } else {
                  this.toastService.presentToast(
                    "¡Ocurrió un error, inténtelo más tarde!"
                  );
                }
              });
          },
        },
      ],
    });

    await alert.present();
  }

  async presentAlertConfirmAct(item) {
    console.log("eventevent", item);

    const alert = await this.alertController.create({
      cssClass: "rm-book-alert",
      header: "¿Desea eliminar esta actividad?",
      message: "",
      buttons: [
        {
          text: "Cancelar",
          role: "cancel",
          cssClass: "secondary",
          handler: (blah) => {},
        },
        {
          text: "Continuar",
          handler: () => {
            let id_actividad = item.activities[0].data.id_actividad;
            console.log("id_actividad", id_actividad);

            this.cursosService
              .deleteAct(this.ID, id_actividad, this.AUTH_KEY)
              .subscribe(
                (res: any) => {
                  // console.log(res);
                  if (res.error == 200) {
                    this.resetDataLoad();
                  } else {
                    //this.router.navigate(["/cursos/"]);
                    console.log(
                      "No se recibieron datos de al elminacion de la actvidad."
                    );
                  }
                },
                (error) => {
                  console.error(
                    "Error al obtener datos de elimancion de actividad:",
                    error
                  );
                }
              );
          },
        },
      ],
    });

    await alert.present();
  }

  expandTr(index) {
    //alert("expand-btn-"+index);
    if (
      jQuery(".expand-btn-" + index)
        .attr("class")
        .includes("initial")
    ) {
      jQuery(".expand-btn-" + index + "")
        .removeClass("initial")
        .addClass("unset");

      jQuery(".tr-content-" + (index + 1)).animate(
        {
          opacity: 1.0,
          left: "-=50",
          height: "toggle",
        },
        200,
        function () {
          // Animation complete.
        }
      );
    } else {
      jQuery(".expand-btn-" + index)
        .removeClass("unset")
        .addClass("initial");
      jQuery(".tr-content-" + (index + 1)).animate(
        {
          opacity: 1.0,
          left: "+=50",
          height: "toggle",
        },
        200,
        function () {
          // Animation complete.
        }
      );
    }
  }

  setBtnInd(id) {
    let color = "light";
    this.ACTIVIDAD_CURSO_CONFIG.forEach((element) => {
      if (element.id == id && element.t_individual == 1) {
        color = "secondary";
      } else {
        color = "light";
      }
    });
    return color;
  }

  setActiveBtnCursoInd(id, flag) {
    this.actividadSelected = id;
    if (this.TIND_Active == flag) {
      this.TIND_Active = -1;
      return;
    } else {
      this.TIND_Active = flag;
    }
    this.searchTipo = 2;

    this.ACTIVIDAD_CURSO_CONFIG.forEach((element) => {
      if (element.id == id) {
        if (element.t_individual == 0) {
          element.t_individual = 0;
          // this.isSearch =true;
          this.usersList = [];
          this.setFilteredItems();
          // this.getStudents(id, "tr-config-curso-" + id, 2);
        } else {
          element.t_individual = 0;
        }
      } else {
        // element.t_individual = 0;
      }
    });
  }

  setActiveBtnInd(id, flag) {
    this.actividadSelected = id;
    if (this.TIND_Active == flag) {
      this.TIND_Active = -1;
      return;
    } else {
      this.TIND_Active = flag;
    }
    // if(this.TIND_Active >= 0){
    //   this.TIND_Active = -1;
    // }else
    // this.TIND_Active = flag;

    this.ACTIVIDADES_CONFIG.forEach((element) => {
      if (element.id_libro == id) {
        if (element.t_individual == 0) {
          element.t_individual = 0;
          this.usersList = [];
          this.setFilteredItems();
          // this.getStudents(id, "tr-config-libro-" + id, 1);
        } else {
          element.t_individual = 0;
        }
      } else {
        // element.t_individual = 0;
      }
    });
  }

  setFilteredItems(search = "") {
    var data = {
      userFilter: search,
      id_curso: this.curso.id,
      id_actividad: this.actividadSelected,
    };
    this.cursosService
      .getStudentsCurse(this.ID, this.AUTH_KEY, data, this.page)
      .subscribe((response) => {
        this.totalpages = response.totalPages;
        this.usersList.push(...response.result);
      });
  }

  removeDuplicates(originalArray, prop) {
    var newArray = [];
    var lookupObject = {};

    for (var i in originalArray) {
      lookupObject[originalArray[i][prop]] = originalArray[i];
    }

    for (i in lookupObject) {
      newArray.push(lookupObject[i]);
    }
    return newArray;
  }

  listenersChckBox1(claseChkbxG) {
    let _this = this;
    jQuery("." + claseChkbxG).on("click", function () {
      let ID_LIBRO = jQuery(this).data("libro");
      // });
      _this.ACTIVIDADES_CONFIG.forEach((ACFelement) => {
        if (ACFelement.id_libro == ID_LIBRO) {
          ACFelement.t_individualArray.forEach((AINDelement) => {
            _this.LIBROS_USERS.push({
              id_libro: ID_LIBRO,
              id_user: AINDelement,
            });
          });
        }
      });

      let checkbox = jQuery(this);
      if (_this.LIBROS_USERS.length > 0) {
        let add = true;
        let index = 0;
        _this.LIBROS_USERS.forEach((element, i, array) => {
          if (element.id_libro == jQuery(this).data("libro")) {
            if (element.id_user == jQuery(this).data("id")) {
              add = false;
              index = i;
            }
          }
        });
        let filtered = [];
        if (!add && !jQuery(this).is(":checked")) {
          //_this.LIBROS_USERS.splice(index,1);
          console.log(
            "DELETE LIBROS_USERS RM: " + jQuery(this).data("id") + " - " + index
          );
          let id_user = jQuery(this).data("id");
          let filtered = _this.LIBROS_USERS.filter(function (value, idx, arr) {
            return value.id_user != id_user;
          });
          console.log("filtered: ", filtered);
          _this.LIBROS_USERS = null;
          _this.LIBROS_USERS = [];
          filtered.forEach((filteredI) => {
            console.log("filteredI: ", filteredI);
            _this.LIBROS_USERS.push(filteredI);
          });

          // _this.LIBROS_USERS = filtered;
          jQuery(this)
            .closest(".card-content-md")
            .find(".img-chk")
            .removeClass("active");
        } else if (add) {
          jQuery(this)
            .closest(".card-content-md")
            .find(".img-chk")
            .addClass("active");

          _this.LIBROS_USERS.push({
            id_libro: jQuery(this).data("libro"),
            id_user: jQuery(this).data("id"),
          });
        }
        console.log(
          "LIBROS_USERS: " + index + "-" + jQuery(this).is(":checked"),
          _this.LIBROS_USERS
        );
      } else {
        _this.LIBROS_USERS.push({
          id_libro: ID_LIBRO,
          id_user: jQuery(this).data("id"),
        });
        jQuery(this)
          .closest(".card-content-md")
          .find(".img-chk")
          .addClass("active");
        console.log("LIBROS_USERS: ", _this.LIBROS_USERS);
      }
    });
  }
  listenersChckBox2(claseChkbxG) {
    let _this = this;
    jQuery("." + claseChkbxG).on("click", function () {
      let ID_CURSO = jQuery(this).data("libro");

      _this.ACTIVIDAD_CURSO_CONFIG.forEach((ACFelement) => {
        if (ACFelement.id == ID_CURSO) {
          ACFelement.t_individualArray.forEach((AINDelement) => {
            _this.CURSOS_USERS.push({
              id_curso: ID_CURSO,
              id_user: AINDelement,
            });
          });
        }
      });

      let checkbox = jQuery(this);
      if (_this.CURSOS_USERS.length > 0) {
        let add = true;
        let index = 0;
        _this.CURSOS_USERS.forEach((element, i, array) => {
          if (element.id_curso == jQuery(this).data("libro")) {
            if (element.id_user == jQuery(this).data("id")) {
              add = false;
              index = i;
            }
          }
        });
        let filtered = [];
        if (!add && !jQuery(this).is(":checked")) {
          //_this.LIBROS_USERS.splice(index,1);
          console.log(
            "DELETE CURSOS_USERS RM: " + jQuery(this).data("id") + " - " + index
          );
          let id_user = jQuery(this).data("id");
          let filtered = _this.CURSOS_USERS.filter(function (value, idx, arr) {
            return value.id_user != id_user;
          });
          console.log("filtered: ", filtered);
          _this.CURSOS_USERS = null;
          _this.CURSOS_USERS = [];
          filtered.forEach((filteredI) => {
            console.log("filteredI: ", filteredI);
            _this.CURSOS_USERS.push(filteredI);
          });
          jQuery(this)
            .closest(".card-content-md")
            .find(".img-chk")
            .removeClass("active");
        } else if (add) {
          _this.CURSOS_USERS.push({
            id_curso: jQuery(this).data("libro"),
            id_user: jQuery(this).data("id"),
          });
          jQuery(this)
            .closest(".card-content-md")
            .find(".img-chk")
            .addClass("active");
        }
        console.log(
          "CURSOS_USERS: " + index + "-" + jQuery(this).is(":checked"),
          _this.CURSOS_USERS
        );
      } else {
        _this.CURSOS_USERS.push({
          id_curso: ID_CURSO,
          id_user: jQuery(this).data("id"),
        });
        jQuery(this)
          .closest(".card-content-md")
          .find(".img-chk")
          .addClass("active");
        console.log("CURSOS_USERS: ", _this.CURSOS_USERS);
      }
    });
  }

  onSearchInput(index, tipo) {
    this.idSearch = index;
    this.searchTipo = tipo;
    console.log("searchTipo: ", this.searchTipo);
  }
  findValueInArray(value, arr) {
    let result = false;
    for (let i = 0; i < arr.length; i++) {
      let name = arr[i];
      if (name == value) {
        result = true;
        break;
      }
    }
    return result;
  }

  selectUsers(id) {
    //Confirmar btn

    this.ACTIVIDADES_CONFIG.forEach((element1) => {
      let array = [];
      if (element1.id_libro == id) array = [];

      this.LIBROS_USERS.forEach((element2, i, arr) => {
        if (element2.id_libro == element1.id_libro && element1.id_libro == id) {
          //element1.t_individualArray.push(element2.id_user);
          if (i == 0) {
          }
          array.push(element2.id_user);
          if (
            !this.findValueInArray(element2.id_user, element1.t_individualArray)
          ) {
          }
        }
      });
      if (element1.id_libro == id) element1.t_individualArray = array;
      // array = [];
    });

    // this.DATA_LIBRO = [];

    console.log(
      "UPDATE this.ACTIVIDADES_CONFIG: " + id,
      this.ACTIVIDADES_CONFIG
    );
  }

  selectUsersCurso(id) {
    console.log("this.CURSOS_USERS: ", this.CURSOS_USERS.length);
    //alert("ID: "+id);
    this.ACTIVIDAD_CURSO_CONFIG.forEach((element1) => {
      let array = [];
      if (element1.idCurso == id) array = [];

      this.CURSOS_USERS.forEach((element2, i, arr) => {
        if (element2.id_curso == element1.id && element1.id == id) {
          if (i == 0) {
          }
          array.push(element2.id_user);
          if (
            !this.findValueInArray(element2.id_user, element1.t_individualArray)
          ) {
          }
        }
      });
      if (element1.id == id) {
        element1.t_individualArray = array;
        console.log(
          "UPDATE ACTIVIDAD_CURSO_CONFIG: ",
          this.ACTIVIDAD_CURSO_CONFIG
        );
      }
    });
  }

  async showSelectDate(titulo, id_libro, id_actividad) {
    const modal = await this.modalCtrl.create({
      component: SeleccionarFechaEntregaComponent,
      cssClass: "select-date-modal",
      backdropDismiss: false,
      componentProps: {
        id_curso: this.curso.id,
        titulo: titulo,
        id_libro: id_libro,
        id_actividad: id_actividad,
      },
    });
    return await modal.present();
  }

  onIonInfinite(event) {
    if (this.page == this.totalpages) {
      (event as InfiniteScrollCustomEvent).target.disabled = true;
    } else {
      this.page++;
      this.setFilteredItems();
      setTimeout(() => {
        (event as InfiniteScrollCustomEvent).target.complete();
      }, 500);
    }
  }

  async presentAlertConfirmAddUser(item) {
    const alert = await this.alertController.create({
      cssClass: "rm-book-alert",
      header: "¿Desea agregar al estudiante?",
      message: "",
      buttons: [
        {
          text: "Cancelar",
          role: "cancel",
          cssClass: "secondary",
          handler: (blah) => {},
        },
        {
          text: "Continuar",
          handler: () => {
            const params = {
              id_actividad: this.actividadSelected,
              id_user: item.id,
            };
            this.cursosService
              .addStudentsCurse(this.ID, this.AUTH_KEY, params)
              .subscribe((res: any) => {
                if (res.validate) {
                  this.toastService.presentToast(
                    "Estudiante agregado correctamente"
                  );
                  this.usersList = [];
                  this.setFilteredItems();
                }
              });
          },
        },
      ],
    });

    await alert.present();
  }
}
